import * as yup from 'yup'

export const societyWebsiteFAQSectionCreateSchema = yup
  .object({
    title: yup.string().required(),
  })
  .required()
